module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-tittle"
  }, [_c('span', [_vm._v("Author’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The tales which follow were written over the last ten years, sometimes to commission, sometimes on a whim, sometimes in an effort to work a fit of bad temper from my system, but always with the entertainment of a particular friend in mind. Some have been published before, as detailed below, but to tinker is only human, so they now appear in a slightly altered form.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Wig – "), _c('i', [_vm._v("His")]), _vm._v(" (Faber and Faber, US)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("Dressing Up In Voices – "), _c('i', [_vm._v("Twenty Under Thirty")]), _vm._v(" (Sceptre)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("Borneo – "), _c('i', [_vm._v("Whitbread Stories One")]), _vm._v(" (Jonathan Cape)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("Other Men’s Sweetness – "), _c('i', [_vm._v("The Ten Commandments")]), _vm._v(" (Serpent’s Tail)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("Old Boys – "), _c('i', [_vm._v("Meanwhile In Another Part of the Forest")]), _vm._v(" (Flamingo)")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_vm._v("The List – "), _c('i', [_vm._v("The Faber Book of Gay Short Stories")]), _vm._v(" (Faber and Faber)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-617a3729","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 69
// module chunks = 0